import { FormResponseType } from '../../Services/Connection/types/FormResponseType';
import InputBuilder from './InputBuilder/InputBuilder';
import { FormExtraType } from './types/FormExtraType';
import ExtraBuilder from './ExtraBuilder/ExtraBuilder';
import { ErrorsResponseType } from '../../Services/Connection/types/ErrorsResponseType';
import createElement from '../../shared/helpers/createElement';
// todo: pourquoi un builder en ts ?
export default class FormBuilder {
  public formElement: HTMLFormElement;

  public formInfos: FormResponseType['form'];

  public formInputsInfos: FormResponseType['inputs'];

  public formExtraInfos: FormResponseType['extra'];

  public formInputs: HTMLElement[] = [];

  public formExtra: FormExtraType = {
    top: [],
    bottom: [],
  };

  constructor(infosFromFetch: FormResponseType) {
    this.formInfos = infosFromFetch.form;
    this.formInputsInfos = infosFromFetch.inputs;
    this.formExtraInfos = infosFromFetch.extra ?? { top: [], bottom: [] };
  }

  public init = async (form?: HTMLFormElement) => {
    if (form) this.prepareFormElement(form);

    await this.createInputs();
    await this.createExtra();
  };

  public prepareFormElement = (form: HTMLFormElement) => {
    this.formElement = form;
    Object.entries(this.formInfos).forEach(([key, value]) =>
      form.setAttribute(key, value)
    );
  };

  public createInputs = async () => {
    this.formInputs = await Promise.all(
      Object.entries(this.formInputsInfos)
        .map(([key, inputInfos]) => {
          if ('data-form-builder-no-render' in inputInfos.attr) return null;

          return InputBuilder.getInput(key, inputInfos);
        })
        .filter(Boolean)
    );
  };

  public createExtra = async () => {
    this.formExtra.top = await Promise.all(
      this.formExtraInfos.top.map((extraInfos) =>
        ExtraBuilder.getExtra(extraInfos)
      )
    );
    this.formExtra.bottom = await Promise.all(
      this.formExtraInfos.bottom
        .map((extraInfos) => ExtraBuilder.getExtra(extraInfos))
        .filter(Boolean)
    );
    this.formExtra.top = this.formExtra.top.filter(Boolean);
    this.formExtra.bottom = this.formExtra.bottom.filter(Boolean);
  };

  public showErrors = (errors: ErrorsResponseType) => {
    Object.entries(errors).forEach(([key, error]) => {
      const input = this.formInputs.find(
        (inputElement) => inputElement.querySelector(`[name="${key}"]`) !== null
      );

      const errorsItems = error.messages.map((message) =>
        createElement(
          'p',
          {
            class: input ? '' : 'c-message c-message--danger',
          },
          input ? message : `<span><b>${key}:</b> ${message}</span>`,
          { isChildrenHTMLString: true }
        )
      );

      if (!input) {
        const errorsWrapper =
          this.formElement.querySelector(':scope > .c-messages') ??
          createElement('div', {
            class: 'c-messages',
          });
        errorsWrapper.replaceChildren(...errorsItems);
        this.formElement.prepend(errorsWrapper);
        return;
      }

      const errorsWrapper =
        input.querySelector('.c-form__invalidFeedback') ??
        createElement('div', {
          class: 'c-form__invalidFeedback',
        });
      errorsWrapper.replaceChildren(...errorsItems);
      input.classList.add('c-form__isInvalid');
      input.append(errorsWrapper);
      input.addEventListener(
        'input',
        () => {
          input.classList.remove('c-form__isInvalid');
          errorsWrapper.replaceChildren();
        },
        { once: true }
      );
    });
  };
}
